import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-width": "1.5",
      d: "m10.099 20.492-.585-.132c-.573-.129-1.03-.317-1.412-.592l-.16-.123v-.001l-.212-.185a3 3 0 0 1-.476-.555h-.001a2.4 2.4 0 0 1-.288-.643l-.064-.256c-.147-.707-.151-1.687-.151-3.276v-.16c0-1.415.002-2.517.103-3.394l.05-.363c.132-.823.38-1.417.832-1.88l.206-.19c.587-.489 1.356-.74 2.482-.866l-.001-.001c1.122-.125 2.582-.125 4.539-.125h.078c1.713 0 3.044 0 4.102.085l.436.042c.985.11 1.697.315 2.252.691l.229.173c.513.427.809.972.976 1.733l.064.34c.15.93.152 2.138.152 3.755v.16c0 1.39-.003 2.315-.102 2.998l-.05.278a2.8 2.8 0 0 1-.238.701l-.114.198v.001c-.125.192-.28.371-.477.554l-.21.185c-.514.427-1.167.672-2.077.811l-.405.054c-1.122.125-2.582.126-4.538.126H15c-.955 0-1.704.303-2.394.728l-.293.19-.005.004q-.231.158-.456.324l-.447.338-.245.185c-.336.254-.684.506-1.061.744z"
    }, null, -1)
  ])))
}
export default { render: render }